import { Modal, message } from 'antd';
import { deleteContact } from '@/services/bff/contact.api';

export function confirmContactDelete(
  contact: { uuid: string; name?: string },
  onDeleted: () => void,
) {
  if (!contact.uuid) return;
  return Modal.confirm({
    closable: { 'aria-label': '关闭' },
    keyboard: true,
    title: '确认删除联系人',
    content: `确认删除联系人“${contact.name || contact.uuid}”吗？删除后不可恢复，并会解除与客户的关联。`,
    okText: '删除',
    cancelText: '取消',
    okButtonProps: { danger: true },
    onOk: async () => {
      try {
        await deleteContact(contact.uuid);
      } catch (error) {
        message.error('联系人删除失败，请重试');
        throw error;
      }
      message.success('联系人删除成功');
      onDeleted();
    },
  });
}
